import { useMemo } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { resolveTokens, type ThemeTokens } from '../constants/constants';

/**
 * 디자인 시스템 토큰 접근 훅.
 *
 * 컴포넌트에서 색상이 필요하면 이 훅만 사용한다.
 *  - `isDark ? COLOR.dark.x : COLOR.x` 같은 분기를 직접 쓰지 않는다.
 *  - Ant Design 기본 색을 사용하지 않는다.
 *
 * @example
 * const t = useThemeTokens();
 * <div style={{ background: t.bgSurface, color: t.textPrimary, border: `1px solid ${t.border}` }}>
 *   <span style={{ color: t.danger }}>하락</span>
 * </div>
 *
 * // 태그
 * const tag = t.tag('naverSuccess');
 *
 * // 워크플로우 스텝
 * const step = t.step('done');
 */
export function useThemeTokens(): ThemeTokens {
  const { isDark } = useTheme();
  return useMemo(() => resolveTokens(isDark), [isDark]);
}